// extracted by mini-css-extract-plugin
export default {"main":"Avatar_main__DEjFG","menu":"Avatar_menu__5hALp","header":"Avatar_header__G-VXX","email":"Avatar_email__dGpSJ","divider":"Avatar_divider__w6-P5"};